import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { listAddresses } from "./thunks/list-addresses";
import { listAmbassadors } from "./thunks/list-ambassadors";
import { listDeliveries, loadMore } from "./thunks/list-deliveries";
import { reassign } from "./thunks/reassign";
import { reschedule } from "./thunks/reschedule";

const name = "allDeliveries";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Only the latest list lands, and a new list voids any "load more" still
      // in flight for the previous filters (DMS-69).
      .addCase(listDeliveries.pending, (state, action) => {
        state.listRequestId = action.meta.requestId;
        state.loadMoreRequestId = null;
        state.isPending = true;
        state.isRejected = false;
      })
      .addCase(listDeliveries.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.listRequestId) return;
        state.rows = action.payload.items;
        state.nextToken = action.payload.nextToken;
        state.summary = action.payload.summary ?? null;
        state.isPending = false;
      })
      .addCase(listDeliveries.rejected, (state, action) => {
        if (action.meta.requestId !== state.listRequestId) return;
        state.isPending = false;
        state.isRejected = true;
      })
      .addCase(loadMore.pending, (state, action) => {
        state.loadMoreRequestId = action.meta.requestId;
      })
      .addCase(loadMore.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.loadMoreRequestId) return;
        state.rows = state.rows.concat(action.payload.items);
        state.nextToken = action.payload.nextToken;
      })
      .addCase(listAmbassadors.fulfilled, (state, action) => {
        state.ambassadors = action.payload;
      })
      .addCase(listAddresses.fulfilled, (state, action) => {
        state.addresses = action.payload;
      })
      .addCase(reassign.pending, (state) => {
        state.isMutating = true;
      })
      .addCase(reassign.fulfilled, (state) => {
        state.isMutating = false;
      })
      .addCase(reassign.rejected, (state) => {
        state.isMutating = false;
      })
      .addCase(reschedule.pending, (state) => {
        state.isMutating = true;
      })
      .addCase(reschedule.fulfilled, (state) => {
        state.isMutating = false;
      })
      .addCase(reschedule.rejected, (state) => {
        state.isMutating = false;
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
